
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

const SEO = ({
  title = "App Gallery",
  description = "Discover and explore applications with App Gallery.",
  keywords = "App Gallery, applications, software, apps",
  canonical="https://appgallery.com.au/",
}: SEOProps) => {
  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Robots */}
      <meta name="robots" content="index, follow" />

      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default SEO;
